(function () {
  if (window.__peOfferPopupInit) return;
  window.__peOfferPopupInit = true;

  const COLLECTION_IDS = {
    diamond: '637671047505',
    accessories: '155127513167',
  };

  const IS_UK_STOREFRONT = window.location.hostname.indexOf('paintingbynumbers-expert.co.uk') !== -1;
  const IS_TARGET_STOREFRONT = ['paintbynumbersforadults.com', 'www.paintbynumbersforadults.com'].includes(window.location.hostname);
  const USE_LIVE_OFFER_PRICES = IS_UK_STOREFRONT || IS_TARGET_STOREFRONT;
  const TEXT = USE_LIVE_OFFER_PRICES
    ? {
        fallbackTitle: "Wait, don't forget these...",
        add: 'Add',
        added: 'Added',
        continue: 'Continue with my purchase',
        defaultError: 'Something went wrong. Please try again.',
        productAdding: 'Your product is being added...',
        offerAdding: 'Offer is being added...',
        offersAdded: 'Offers added. Your product is being added...',
        offerAdded: 'Added. You can choose another offer or continue.',
        loadingPrice: 'Loading price...',
        pricesError: 'Prices could not be loaded. You can continue with your item or try again.',
      }
    : {
        fallbackTitle: 'Wacht, vergeet deze niet...',
        add: 'Toevoegen',
        added: 'Toegevoegd',
        continue: 'Doorgaan met mijn aankoop',
        defaultError: 'Er ging iets mis. Probeer het opnieuw.',
        productAdding: 'Je product wordt toegevoegd...',
        offerAdding: 'Aanbieding wordt toegevoegd...',
        offersAdded: 'Aanbiedingen toegevoegd. Je product wordt toegevoegd...',
        offerAdded: 'Toegevoegd. Je kunt nog een aanbieding kiezen of doorgaan.',
      };

  const UK_OFFER_COPY = {
    53731989881169: {
      title: 'Number Remover',
      price: '£13',
      compareAtPrice: '£15',
      imageAlt: 'Number Remover',
    },
    53576171880785: {
      title: 'Acrylic Varnish',
      price: '£16',
      compareAtPrice: '£29',
      imageAlt: 'Acrylic Varnish',
    },
    53903266152785: {
      title: 'Premium storage box with 28 pots',
      price: '£18',
      compareAtPrice: '£27',
      imageAlt: 'Premium storage box with 28 pots',
    },
    53903282831697: {
      title: 'Diamond Painting Wax',
      price: '£12',
      compareAtPrice: '£18',
      imageAlt: 'Diamond Painting Wax',
    },
  };

  const TARGET_OFFER_COPY = {
    53731989881169: { title: 'Number Remover', imageAlt: 'Paint by numbers number remover' },
    53576171880785: { title: 'Acrylic Varnish', imageAlt: 'Acrylic varnish' },
    53549591527761: { title: 'Fine Detail Paintbrushes', imageAlt: 'Fine detail paintbrushes' },
    53903266152785: { title: 'Premium Storage Box with 28 Pots', imageAlt: 'Premium storage box with 28 pots' },
    53903282831697: { title: 'Diamond Painting Wax', imageAlt: 'Diamond painting wax' },
  };
  const OFFER_HANDLES = {
    53731989881169: 'painting-expert-numbers-verwijderaar-paint-by-numbers',
    53576171880785: 'acrylic-varnish',
    53549591527761: 'fine-line-brushes',
    53903266152785: 'premium-storage-box-with-28-jars',
    53903282831697: 'sticky-wax',
  };
  let priceLoadGeneration = 0;

  async function loadLiveOfferPrices(config) {
    const currency = window.Shopify?.currency?.active;
    if (!/^[A-Z]{3}$/.test(currency || '')) throw new Error(TEXT.pricesError);
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency });
    const offers = await Promise.all(config.offers.map(async (offer) => {
      const handle = OFFER_HANDLES[offer.id];
      if (!handle) throw new Error(TEXT.pricesError);
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch('/products/' + handle + '.js?offer_price=' + Date.now(), { cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(TEXT.pricesError);
        const product = await response.json();
        const variant = product.variants?.find((item) => String(item.id) === String(offer.id));
        if (!variant || !Number.isInteger(variant.price) || variant.price < 0) throw new Error(TEXT.pricesError);
        // Format Shopify's actual minor-unit price. Never calculate or round a new selling price here.
        return { ...offer, price: formatter.format(variant.price / 100),
          compareAtPrice: Number.isInteger(variant.compare_at_price) && variant.compare_at_price > variant.price ? formatter.format(variant.compare_at_price / 100) : '',
          livePriceReady: true, liveUnitPrice: variant.price, liveCurrency: currency };
      } finally { clearTimeout(timer); }
    }));
    if (window.Shopify?.currency?.active !== currency) throw new Error(TEXT.pricesError);
    return { ...config, offers };
  }

  const POPUP_CONFIGS = {
    standard: {
      title: 'Wacht, vergeet deze niet...',
      offers: [
        {
          id: '53731989881169',
          title: 'Painting Expert Nummer Verwijderaar',
          price: '€12,95',
          compareAtPrice: '',
          image: 'https://cdn.shopify.com/s/files/1/0277/3614/5999/files/PaintingExpertNummerVerwijderaar.webp?v=1778354360',
          imageAlt: 'Painting Expert Nummer Verwijderaar',
        },
        {
          id: '53576171880785',
          title: 'Acryl Vernis',
          price: '€16,95',
          compareAtPrice: '€31,99',
          image: 'https://cdn.shopify.com/s/files/1/0277/3614/5999/files/AcrylVernis.webp?v=1776665163',
          imageAlt: 'Acryl Vernis',
        },
        {
          id: '53549591527761',
          title: 'Fijne lijn penselen',
          price: '€19,95',
          compareAtPrice: '€24,00',
          image: 'https://paintingexpert.nl/cdn/shop/files/Fijnelijnpenselen.webp?width=360',
          imageAlt: 'Fijne lijn penselen',
        },
      ],
    },
    diamond: {
      title: 'Wacht, vergeet deze niet...',
      offers: [
        {
          id: '53903266152785',
          title: 'Premium opbergbox met 28 potjes',
          price: '€19,95',
          compareAtPrice: '€29,95',
          image: 'https://cdn.shopify.com/s/files/1/0277/3614/5999/files/image_9a0e2e0b-a6c5-425a-a7ff-c2346ed942bb.webp?v=1780053463',
          imageAlt: 'Premium opbergbox met 28 potjes',
        },
        {
          id: '53903282831697',
          title: 'Wax voor Diamond Painting',
          price: '€12,95',
          compareAtPrice: '€19,95',
          image: 'https://cdn.shopify.com/s/files/1/0277/3614/5999/files/image.jpg?v=1780053629',
          imageAlt: 'Wax voor Diamond Painting',
        },
      ],
    },
  };

  const EXCLUDED_PRODUCT_IDS = new Set(['10794879058257', '10762019602769', '10837068513617', '10837079097681']);
  const EXCLUDED_COLLECTION_IDS = new Set([COLLECTION_IDS.accessories]);

  const selectors = {
    mainProductForm: 'form[data-product-form]',
    addButton: '[data-add-to-cart], button[name="add"]',
    excludedTrigger: '[data-quick-add-btn], [data-add-to-cart-bar], [data-cart-bar-scroll], [data-sibling-swapper]',
    excludedContainer: 'quick-add-product, [data-quick-add-holder], [data-product-upsell-container], [data-upsell-products], [data-cart-drawer], .drawer--cart, .product__siblings',
  };

  const state = {
    modal: null,
    modalTitle: null,
    modalGrid: null,
    status: null,
    originalFormData: null,
    lastFocusedElement: null,
    addedOfferIds: new Set(),
    offers: [],
    busy: false,
  };

  function getPopupContext() {
    const context = window.PEOfferPopupContext || {};

    return {
      productId: context.productId == null ? '' : String(context.productId),
      collectionIds: Array.isArray(context.collectionIds) ? context.collectionIds.map((collectionId) => String(collectionId)) : [],
    };
  }

  function getPopupConfig() {
    const { collectionIds } = getPopupContext();

    if (collectionIds.some((collectionId) => EXCLUDED_COLLECTION_IDS.has(collectionId))) {
      return null;
    }

    const config = collectionIds.includes(COLLECTION_IDS.diamond)
      ? POPUP_CONFIGS.diamond
      : POPUP_CONFIGS.standard;

    return localizePopupConfig(config);
  }

  function localizePopupConfig(config) {
    if (!config) return config;
    if (IS_TARGET_STOREFRONT) return {
      ...config, title: TEXT.fallbackTitle,
      offers: config.offers.map((offer) => ({ ...offer, ...(TARGET_OFFER_COPY[offer.id] || {}), price: TEXT.loadingPrice, compareAtPrice: '', livePriceReady: false })),
    };
    if (!IS_UK_STOREFRONT) return config;

    return {
      ...config,
      title: TEXT.fallbackTitle,
      offers: config.offers.map((offer) => ({
        ...offer,
        ...(UK_OFFER_COPY[offer.id] || {}),
        price: TEXT.loadingPrice, compareAtPrice: '', livePriceReady: false,
      })),
    };
  }

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function isExcludedProductContext() {
    const { productId } = getPopupContext();
    const popupConfig = getPopupConfig();

    return EXCLUDED_PRODUCT_IDS.has(productId) || popupConfig == null;
  }

  function getAddUrl() {
    const route = window.theme?.routes?.cart_add_url || '/cart/add';
    return route.endsWith('.js') ? route : `${route}.js`;
  }

  function getCartUrl() {
    const route = window.theme?.routes?.cart_url || '/cart';
    return route.endsWith('.js') ? route : `${route.replace(/\/$/, '')}.js`;
  }

  function isDisabledButton(button) {
    return Boolean(
      button?.disabled
      || button?.getAttribute?.('aria-disabled') === 'true'
      || button?.hasAttribute?.('disabled')
    );
  }

  function isExcludedTrigger(button) {
    return Boolean(
      button?.closest?.(selectors.excludedTrigger)
      || button?.closest?.(selectors.excludedContainer)
    );
  }

  function isMainAddButton(button) {
    return Boolean(
      button?.matches?.(selectors.addButton)
      && !isDisabledButton(button)
      && !isExcludedTrigger(button)
    );
  }

  function getMainProductFormFromButton(button) {
    if (!isMainAddButton(button) || !isProductPage() || isExcludedProductContext()) {
      return null;
    }

    const form = button.closest(selectors.mainProductForm);

    if (!form || !form.contains(button)) {
      return null;
    }

    return form;
  }

  function getOriginalFormData(form) {
    const formData = new FormData(form);

    if (!formData.get('id') && !formData.has('items[0][id]')) {
      const variantInput = form.querySelector('[name="id"]')
        || form.closest('product-form')?.querySelector('[name="id"]')
        || document.querySelector('form[data-product-form] [name="id"]');

      if (variantInput?.value) {
        formData.set('id', variantInput.value);
      }
    }

    if (!formData.get('quantity') && !formData.has('items[0][id]')) {
      formData.set('quantity', '1');
    }

    return formData;
  }

  function stopNativeAdd(event) {
    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function formatError(error) {
    if (!error) return TEXT.defaultError;
    return error.description || error.message || String(error);
  }

  function setStatus(message, isError) {
    if (!state.status) return;
    state.status.textContent = message || '';
    state.status.classList.toggle('is-error', Boolean(isError));
    state.status.hidden = !message;
  }

  function setBusy(isBusy) {
    state.busy = isBusy;

    if (!state.modal) return;

    state.modal.querySelectorAll('button').forEach((button) => {
      if (button.hasAttribute('data-pe-offer-close')) {
        button.disabled = false;
        return;
      }

      button.disabled = isBusy || button.hasAttribute('data-pe-added') || (USE_LIVE_OFFER_PRICES && button.hasAttribute('data-pe-price-pending'));
    });
  }

  function requestCartRefresh(openCart) {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
    } else {
      fetch(getCartUrl(), { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (!cart) return;

          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: {
              cartCount: Number(cart.item_count || 0),
            },
          }));
        })
        .catch(() => {});
    }

    if (openCart) {
      document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
    }
  }

  async function addToCart(body) {
    const isFormData = body instanceof FormData;
    const response = await fetch(getAddUrl(), {
      method: 'POST',
      headers: isFormData
        ? {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
          }
        : {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
      body: isFormData ? body : JSON.stringify(body),
    });

    const payload = await response.json().catch(() => ({}));

    if (!response.ok || payload.status) {
      throw payload;
    }

    return payload;
  }

  function renderOfferCards(offers) {
    return offers.map((offer, index) => {
      const compareAtPrice = offer.compareAtPrice
        ? `<span class="pe-offer-popup__compare">${offer.compareAtPrice}</span>`
        : '';

      return `
        <article class="pe-offer-popup__card" data-pe-offer-card="${offer.id}">
          <div class="pe-offer-popup__image-wrap">
            <img class="pe-offer-popup__image" src="${offer.image}" alt="${offer.imageAlt}" loading="eager">
          </div>
          <h3 class="pe-offer-popup__product-title">${offer.title}</h3>
          <p class="pe-offer-popup__price">
            ${compareAtPrice}
            <span class="pe-offer-popup__sale">${offer.price}</span>
          </p>
          <button class="pe-offer-popup__add" type="button" data-pe-offer-add="${index}" ${USE_LIVE_OFFER_PRICES && !offer.livePriceReady ? 'disabled data-pe-price-pending' : ''}>
            ${TEXT.add}
          </button>
        </article>
      `;
    }).join('');
  }

  function syncModalContent(config) {
    if (!state.modalTitle || !state.modalGrid) return;

    state.offers = Array.isArray(config?.offers) ? config.offers : [];
    state.modalTitle.textContent = config?.title || TEXT.fallbackTitle;
    state.modalGrid.innerHTML = renderOfferCards(state.offers);
  }

  function ensureModal() {
    if (state.modal) return state.modal;

    const wrapper = document.createElement('div');
    wrapper.className = 'pe-offer-popup';
    wrapper.hidden = true;
    wrapper.innerHTML = `
      <div class="pe-offer-popup__overlay" data-pe-offer-dismiss></div>
      <section class="pe-offer-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="pe-offer-popup-title">
        <header class="pe-offer-popup__header">
          <h2 class="pe-offer-popup__title" id="pe-offer-popup-title">${TEXT.fallbackTitle}</h2>
          <button class="pe-offer-popup__close" type="button" aria-label="${TEXT.continue}" data-pe-offer-close>
            <span aria-hidden="true">×</span>
          </button>
        </header>
        <div class="pe-offer-popup__body">
          <div class="pe-offer-popup__grid" data-pe-offer-grid></div>
        </div>
        <div class="pe-offer-popup__footer">
          <p class="pe-offer-popup__status" data-pe-offer-status hidden></p>
          <button class="pe-offer-popup__continue" type="button" data-pe-offer-continue>
            ${TEXT.continue}
          </button>
        </div>
      </section>
    `;

    document.body.appendChild(wrapper);
    state.modal = wrapper;
    state.modalTitle = wrapper.querySelector('#pe-offer-popup-title');
    state.modalGrid = wrapper.querySelector('[data-pe-offer-grid]');
    state.status = wrapper.querySelector('[data-pe-offer-status]');

    wrapper.addEventListener('click', handleModalClick);
    document.addEventListener('keydown', handleKeydown);

    return wrapper;
  }

  function updateOfferState(offerId) {
    const card = state.modal?.querySelector(`[data-pe-offer-card="${offerId}"]`);
    const button = card?.querySelector('[data-pe-offer-add]');

    if (!card || !button) return;

    card.classList.add('is-added');
    button.textContent = TEXT.added;
    button.setAttribute('data-pe-added', 'true');
    button.disabled = true;
  }

  function openPopup(form) {
    const popupConfig = getPopupConfig();
    if (!popupConfig) return;

    const modal = ensureModal();
    syncModalContent(popupConfig);

    state.originalFormData = getOriginalFormData(form);
    state.lastFocusedElement = document.activeElement;
    state.addedOfferIds = new Set();
    setBusy(false);

    modal.querySelectorAll('.pe-offer-popup__card').forEach((card) => card.classList.remove('is-added'));
    modal.querySelectorAll('[data-pe-offer-add]').forEach((button) => {
      button.textContent = TEXT.add;
      button.removeAttribute('data-pe-added');
      button.disabled = USE_LIVE_OFFER_PRICES && button.hasAttribute('data-pe-price-pending');
    });

    setStatus('', false);
    modal.hidden = false;
    document.documentElement.classList.add('pe-offer-popup-open');

    modal.classList.add('is-visible');
    modal.querySelector('[data-pe-offer-add]:not([disabled])')?.focus({preventScroll:true});
    if (USE_LIVE_OFFER_PRICES) {
      const generation = ++priceLoadGeneration;
      loadLiveOfferPrices(popupConfig).then((loaded) => {
        if (generation !== priceLoadGeneration || !isPopupOpen() || !state.originalFormData) return;
        syncModalContent(loaded);
        setBusy(state.busy);
      }).catch(() => {
        if (generation !== priceLoadGeneration || !isPopupOpen() || !state.originalFormData) return;
        setStatus(TEXT.pricesError, true);
      });
    }
  }

  function closePopup() {
    if (!state.modal || state.busy) return;
    state.modal.classList.remove('is-visible');
    state.modal.hidden = true;
    state.originalFormData = null;
    document.documentElement.classList.remove('pe-offer-popup-open');
    if (state.lastFocusedElement?.isConnected) state.lastFocusedElement.focus({preventScroll:true});
  }

  function isPopupOpen() {
    return Boolean(state.modal && !state.modal.hidden);
  }

  async function completeOriginalPurchase() {
    if (!state.originalFormData || state.busy) return;

    setBusy(true);
    setStatus(TEXT.productAdding, false);

    try {
      await addToCart(state.originalFormData);
      setBusy(false);
      closePopup();
      requestCartRefresh(true);
    } catch (error) {
      setStatus(formatError(error), true);
      setBusy(false);
    }
  }

  async function addOffer(index) {
    const offer = state.offers[index];

    if (!offer || state.busy || state.addedOfferIds.has(offer.id) || (USE_LIVE_OFFER_PRICES && !offer.livePriceReady)) return;

    setBusy(true);
    setStatus(TEXT.offerAdding, false);

    try {
      await addToCart({
        items: [
          {
            id: Number(offer.id),
            quantity: 1,
          },
        ],
      });

      state.addedOfferIds.add(offer.id);
      updateOfferState(offer.id);

      if (state.addedOfferIds.size >= state.offers.length) {
        setStatus(TEXT.offersAdded, false);
        setBusy(false);
        await completeOriginalPurchase();
        return;
      }

      setStatus(TEXT.offerAdded, false);
      setBusy(false);
    } catch (error) {
      setStatus(formatError(error), true);
      setBusy(false);
    }
  }

  function handleModalClick(event) {
    const closeButton = event.target.closest('[data-pe-offer-close]');
    const dismissButton = event.target.closest('[data-pe-offer-dismiss]');
    const continueButton = event.target.closest('[data-pe-offer-continue]');
    const offerButton = event.target.closest('[data-pe-offer-add]');

    if (closeButton) {
      if (state.busy) return;
      completeOriginalPurchase();
      return;
    }

    if (dismissButton) {
      closePopup();
      return;
    }

    if (continueButton) {
      completeOriginalPurchase();
      return;
    }

    if (offerButton) {
      addOffer(Number(offerButton.getAttribute('data-pe-offer-add')));
    }
  }

  function handleKeydown(event) {
    if (!state.modal || state.modal.hidden) return;

    if (event.key === 'Escape') {
      closePopup();
    }
  }

  function handleSubmit(event) {
    const form = event.target?.matches?.(selectors.mainProductForm) ? event.target : null;
    const submitter = event.submitter || form?.querySelector('button[type="submit"][data-add-to-cart], button[name="add"]');

    if (!form || !submitter || getMainProductFormFromButton(submitter) !== form) return;

    if (isPopupOpen()) {
      stopNativeAdd(event);
      return;
    }

    if (state.busy) { stopNativeAdd(event); return; }
    if (form.classList.contains('uploadkit-invalid') || !form.checkValidity()) return;

    stopNativeAdd(event);
    openPopup(form);
  }

  function handleClick(event) {
    const button = event.target?.closest?.(selectors.addButton);

    if (!button) return;

    const form = getMainProductFormFromButton(button);

    if (!form) return;

    if (isPopupOpen()) {
      stopNativeAdd(event);
      return;
    }

    if (state.busy) { stopNativeAdd(event); return; }
    if (form.classList.contains('uploadkit-invalid') || !form.checkValidity()) return;

    stopNativeAdd(event);
    openPopup(form);
  }

  function injectStyles() {
    if (document.getElementById('pe-offer-popup-styles')) return;

    const style = document.createElement('style');
    style.id = 'pe-offer-popup-styles';
    style.textContent = `
      .pe-offer-popup-open { overflow: hidden; }
      .pe-offer-popup[hidden] { display: none; }
      .pe-offer-popup {
        position: fixed;
        inset: 0;
        z-index: 100200;
        display: grid;
        place-items: center;
        padding: 18px;
        opacity: 0;
        transition: opacity 180ms ease;
      }
      .pe-offer-popup.is-visible { opacity: 1; }
      .pe-offer-popup__overlay {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.58);
        backdrop-filter: blur(3px);
      }
      .pe-offer-popup__dialog {
        position: relative;
        width: min(760px, 100%);
        max-height: min(92vh, 760px);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        background: #ffffff;
        border-radius: 14px;
        box-shadow: 0 18px 55px rgba(0, 0, 0, 0.28);
        transform: translateY(8px) scale(0.98);
        transition: transform 180ms ease;
      }
      .pe-offer-popup.is-visible .pe-offer-popup__dialog {
        transform: translateY(0) scale(1);
      }
      .pe-offer-popup__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 18px 16px 16px;
        border-bottom: 1px solid #d5e4dc;
      }
      .pe-offer-popup__title {
        margin: 0;
        color: #20574e;
        font-family: inherit;
        font-size: 22px;
        font-weight: 800;
        line-height: 1.2;
      }
      .pe-offer-popup__close {
        width: 34px;
        height: 34px;
        display: grid;
        place-items: center;
        flex: 0 0 auto;
        border: 0;
        background: transparent;
        color: #45675e;
        cursor: pointer;
        font-size: 34px;
        line-height: 1;
      }
      .pe-offer-popup__body {
        padding: 16px;
        overflow-y: auto;
      }
      .pe-offer-popup__grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 14px;
      }
      .pe-offer-popup__card {
        min-width: 0;
        text-align: center;
      }
      .pe-offer-popup__image-wrap {
        aspect-ratio: 1 / 1;
        overflow: hidden;
        border: 1px solid #d5e4dc;
        border-radius: 14px;
        background: #f4f8f6;
      }
      .pe-offer-popup__image {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
      .pe-offer-popup__product-title {
        min-height: 42px;
        margin: 8px 0 4px;
        color: #20574e;
        font-family: inherit;
        font-size: 16px;
        font-weight: 800;
        line-height: 1.25;
      }
      .pe-offer-popup__price {
        min-height: 24px;
        margin: 0 0 10px;
        font-size: 15px;
        line-height: 1.4;
      }
      .pe-offer-popup__compare {
        margin-right: 4px;
        color: #677970;
        text-decoration: line-through;
      }
      .pe-offer-popup__sale {
        color: #20574e;
      }
      .pe-offer-popup__add,
      .pe-offer-popup__continue {
        min-height: 40px;
        width: 100%;
        border: 1px solid #20574e;
        border-radius: 6px;
        background: #20574e;
        color: #ffffff;
        cursor: pointer;
        font: inherit;
        font-size: 15px;
        font-weight: 800;
        line-height: 1.2;
        text-transform: uppercase;
        transition: background 150ms ease, color 150ms ease, opacity 150ms ease;
      }
      .pe-offer-popup__add:hover,
      .pe-offer-popup__continue:hover {
        background: #173e38;
      }
      .pe-offer-popup__add:disabled,
      .pe-offer-popup__continue:disabled {
        cursor: wait;
        opacity: 0.72;
      }
      .pe-offer-popup__card.is-added .pe-offer-popup__add {
        border-color: #268458;
        background: #268458;
        cursor: default;
      }
      .pe-offer-popup__status {
        margin: 14px 0 0;
        color: #456057;
        font-size: 14px;
        line-height: 1.35;
        text-align: center;
      }
      .pe-offer-popup__status.is-error {
        color: #b42318;
      }
      .pe-offer-popup__continue {
        margin-top: 14px;
        background: #ffffff;
        color: #20574e;
      }
      .pe-offer-popup__continue:hover {
        background: #edf5f0;
      }
      @media (max-width: 520px) {
        .pe-offer-popup {
          place-items: center;
          padding: 10px;
        }
        .pe-offer-popup__dialog {
          width: 100%;
          max-height: 88vh;
        }
        .pe-offer-popup__header {
          padding: 15px 14px 13px;
        }
        .pe-offer-popup__title {
          font-size: 19px;
        }
        .pe-offer-popup__body {
          padding: 12px;
        }
        .pe-offer-popup__grid {
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 10px;
        }
        .pe-offer-popup__product-title {
          min-height: 38px;
          font-size: 14px;
        }
        .pe-offer-popup__price {
          font-size: 13px;
        }
        .pe-offer-popup__add,
        .pe-offer-popup__continue {
          min-height: 38px;
          font-size: 13px;
        }
      }

      .pe-offer-popup__card {display:flex;flex-direction:column;align-items:stretch;}
      .pe-offer-popup__image-wrap {flex:none;}
      .pe-offer-popup__product-title {flex:1;margin:12px 0 10px;font-weight:700;}
      .pe-offer-popup__price {display:flex;flex-wrap:wrap;align-items:baseline;justify-content:center;gap:6px;flex:none;margin:0 0 14px;}
      .pe-offer-popup__compare {margin:0;}
      .pe-offer-popup__sale {font-weight:700;}
      .pe-offer-popup__add {flex:none;min-height:44px;}
      .pe-offer-popup__continue {min-height:44px;}
      .pe-offer-popup__add:focus-visible,.pe-offer-popup__continue:focus-visible,.pe-offer-popup__close:focus-visible {outline:3px solid #308980;outline-offset:3px;}

      /* Three offers stay on one row; the purchase action never scrolls away. */
      .pe-offer-popup {padding:12px;}
      .pe-offer-popup__dialog {max-height:calc(100vh - 24px);max-height:calc(100dvh - 24px);}
      .pe-offer-popup__header {flex:none;}
      .pe-offer-popup__body {flex:1 1 auto;min-height:0;overscroll-behavior:contain;}
      .pe-offer-popup__footer {flex:none;padding:12px 16px max(12px,env(safe-area-inset-bottom));border-top:1px solid #d5e4dc;background:#fff;}
      .pe-offer-popup__footer .pe-offer-popup__continue {margin:0;min-height:44px;}
      .pe-offer-popup__footer .pe-offer-popup__status {margin:0 0 10px;max-height:4em;overflow:auto;}
      .pe-offer-popup__grid {grid-template-columns:repeat(3,minmax(0,1fr));}
      .pe-offer-popup__grid:has(> :last-child:nth-child(2)) {grid-template-columns:repeat(2,minmax(0,1fr));}
      @media(max-width:520px){
        .pe-offer-popup {padding:10px;}
        .pe-offer-popup__dialog {max-height:calc(100vh - 20px);max-height:calc(100dvh - 20px);}
        .pe-offer-popup__header {padding:12px;gap:8px;}
        .pe-offer-popup__title {font-size:18px;}
        .pe-offer-popup__body {padding:12px 10px;}
        .pe-offer-popup__grid {gap:8px;}
        .pe-offer-popup__image-wrap {border-radius:8px;}
        .pe-offer-popup__product-title {font-size:12px;line-height:1.3;margin:8px 0;min-height:0;overflow-wrap:anywhere;}
        .pe-offer-popup__price {font-size:12px;line-height:1.3;gap:3px;margin-bottom:8px;}
        .pe-offer-popup__compare {font-size:10px;}
        .pe-offer-popup__add {font-size:10px;letter-spacing:0;padding:7px 2px;min-height:44px;}
        .pe-offer-popup__footer {padding:10px 12px max(10px,env(safe-area-inset-bottom));}
        .pe-offer-popup__footer .pe-offer-popup__continue {font-size:12px;padding:10px;}
      }
      @media(max-height:500px){.pe-offer-popup__header{padding-block:8px}.pe-offer-popup__image-wrap{max-height:120px;aspect-ratio:auto}.pe-offer-popup__image{height:120px;object-fit:contain}.pe-offer-popup__body{padding-block:10px}}
    `;

    document.head.appendChild(style);
  }

  function init() {
    if (!isProductPage() || isExcludedProductContext()) return;

    injectStyles();
    document.addEventListener('click', handleClick, true);
    document.addEventListener('submit', handleSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
